module.exports = "/images/vendor/svg-country-flags/svg/gb.svg?880efdae8333a77ffdf9bd164fe42b45";